import { defineComponent, ref, computed, nextTick } from 'vue';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import { SHOW_BRAND } from '@/utils';
import EventBusItemDetail from '@/eventBus/itemDetail';
import GetAccountFormVue from './GetAccountForm.vue';
export default defineComponent({
  name: 'LoginDialog',
  components: {
    EnvironmentOutlined: EnvironmentOutlined,
    GetAccountFormVue: GetAccountFormVue
  },
  props: {
    showCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  setup: function (props) {
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var itemDetailData = ref(null);
    EventBusItemDetail.on('item-new', function (item) {
      // console.log('EventBusItemDetail --> 1222 item-new', item);
      itemDetailData.value = item;
    });
    // ============================================
    var loginInfo = computed(function () {
      return loginService.accountInfo;
    });
    var applyToLogin = function () {
      loginService.toggleAccountInfoVisible(false);
      loginService.showLoginDialog();
      nextTick(function () {
        EventBusItemDetail.emit('refill-login-info', {
          account: loginInfo.value.account ? loginInfo.value.account.toString() : '',
          password: loginInfo.value.pwd
        });
      });
    };
    return {
      userService: userService,
      loginService: loginService,
      SHOW_BRAND: SHOW_BRAND,
      props: props,
      itemDetailData: itemDetailData,
      loginInfo: loginInfo,
      applyToLogin: applyToLogin
    };
  }
});